import { render, staticRenderFns } from "./importSku.vue?vue&type=template&id=2e8989fd&"
import script from "./importSku.vue?vue&type=script&lang=js&"
export * from "./importSku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports